import { Page, PageTitle } from "@/components/page"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Table } from "lucide-react"
import { DataTable } from "@/components/datatable/datatable"

export const logsdev = {
  title: "Logs",
  description: "Log data.",
  route: "/evaluation/logs",
  url: "/evaluation/logs",
  icon: Table,
  component,
  resource: "logs",
  action: "read",
  group: "dev",
} satisfies PageConfig


const columns: Columns<Table<"logs">> = {
  id: { header: "ID", },
  uid: { header: "UID" },
  created_at: { header: "Created", cell: DataTable.cellRender.date, },
  agent: { header: "Agent" },
  team_id: { header: "Team" },
  type: { header: "Type" },
  worker: { header: "Worker" },
  message: { header: "Message" },
  parameters: { header: "Parameters", cell: DataTable.cellRender.json },
  handles: { header: "Handles", cell: DataTable.cellRender.json, },
  inputTokens: { header: "Input Tokens", cell: DataTable.cellRender.number },
  outputTokens: { header: "Output Tokens", cell: DataTable.cellRender.number },
}

function component() {
  return <Page >
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <PageTitle />
      <DataTableSupabase columns={columns} table="logs" realtime showSelection sort={["created_at", "desc"]} enableServerSideFiltering={true} searchableColumns={["message", "agent", "worker"]}>
      </DataTableSupabase>
    </div>
  </Page>
}

